import React, { useEffect, useRef } from "react"
import { HubspotFormWrapper } from "./HubspotForm.styles"

const HUBSPOT_SCRIPT_SRC = "//js-eu1.hsforms.net/forms/embed/v2.js";

const loadHubspotScript = () => new Promise((resolve) => {
  if (window.hbspt) {
    resolve();
    return;
  }
  let script = document.querySelector(`script[src="${HUBSPOT_SCRIPT_SRC}"]`);
  if (!script) {
    script = document.createElement('script');
    script.src = HUBSPOT_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }
  script.addEventListener('load', () => resolve());
});

const HubSpotFormPopup = ({ isVisible, onClose }) => {

  const formHolder = useRef(null);

  // The form is created from React (rather than an inline script) so hydration can't wipe it,
  // and is recreated whenever the popup opens with an empty holder.
  useEffect(() => {
    if (formHolder.current && formHolder.current.childElementCount > 0) return;

    loadHubspotScript().then(() => {
      if (!formHolder.current || formHolder.current.childElementCount > 0) return;
      window.hbspt.forms.create({
        region: "eu1",
        portalId: "141862351",
        formId: "8c31da6e-a395-471c-8689-3b1fd3b0b7c0",
        target: '#hubspotForm'
      });
    });
  }, [isVisible]);

  const popupClass = isVisible ? 'hubspot-form-popup visible' : 'hubspot-form-popup';

  return (
    <HubspotFormWrapper className={popupClass}>
      <div className="hubspot-form-overlay" onClick={onClose}></div>
      <div className="hubspot-form-content">
        <div className="form-title">
          <h2 className="h5 text-white m-0 text-center">
            Request your FREE Payment Optimisation Assessment!
          </h2>
        </div>
        <button className="close-button" onClick={onClose}></button>
        <div id="hubspotForm" ref={formHolder}></div>
      </div>
    </HubspotFormWrapper>
  );
};

export default HubSpotFormPopup;
